import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class Answers extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAnswersApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.state = {
            language: null,
            data: [
                {
                    id: '',
                    answer: '',
                    originalQuestionId: '',
                    // categoryTags: '',
                    autoTranslate: '',
                    alias: '',
                }
            ],
            pageNum : null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    NotifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var ansController = this;
        if(ansController.state.pageNum != 0) {
            ansController.setState({pageNum : 0})
        }
        this.state.data.unshift({
            id: '',
            answer: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    addAnswersApi = (props, e) => {
        this.state.data[props.index].answer = document.getElementById("answer" + props.index).innerText.trim();
        this.state.data[props.index].autoTranslate = document.getElementById("autoTranslate" + props.index).checked;
        this.state.editedId = "-1";
        this.setState(this.state);
        var validateResult = this.validateCells(props.original.answer);

        if (validateResult == true) {
            var addedData = {
                questionId: this.props.location.state.faqid,
                answer: this.state.data[props.index].answer,
                autoTranslate: this.state.data[props.index].autoTranslate,
            };

            var thisController = this
            $.ajax({
                url: "/api/faq-answer",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                data: addedData,
                success: function (res) {
                    if (res.success === true) {
                        // addAnswerController.setState({ hideAddDialog: true });
                        thisController.NotifyAdd();
                        thisController.state.disabled = false;
                        thisController.fetchAnswersApi();
                    } else {
                        if(res.result!=""){
                            thisController.notifyFailedToAdd(res.result);
                            thisController.state.disabled = false;
                        }
                        else{
                            thisController.NotifyFailToLoad();
                            thisController.state.disabled = false;
                        }
                        
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    NotifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Answer Added Successfully</b>, {
            position: "top-center",

        });

    }

    notifyFailedToAdd(response){
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateAnswerApi(props, e) {
        this.state.data[props.index].answer = document.getElementById("answer" + props.index).innerText.trim();
        this.state.data[props.index].autoTranslate = document.getElementById("autoTranslate" + props.index).checked;
        var validateResult = this.validateCells(props.original.answer);
        if (validateResult == true) {
            var updatedData = {
                answer: this.state.data[props.index].answer,
                questionId: this.props.location.state.faqid,
                answerId: this.state.data[props.index].id,
                autoTranslate: this.state.data[props.index].autoTranslate,
            };
            var thisController = this
            $.ajax({
                url: "/api/faq-answer-update",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'contentType': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                data: updatedData,
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdated();
                        thisController.state.disabled = false;
                        thisController.fetchAnswersApi();
                    } else {
                        if(res.result!=""){
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                        else{
                            thisController.notifyFailedToUpdate(res.result);
                            thisController.state.disabled = false;
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Answer Updated Successfully</b>, {
            position: "top-center",

        });
    }

    notifyFailedToUpdate(response){
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(answer) {
        if ((answer == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
                toast(<b><img src="assets/images/warn.svg"
                    style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
                    &nbsp;&nbsp;Please fill all the fields</b>, {
                    position: "top-center"
                });

    }

    deleteAnswersApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        }
        $.ajax({
            url: "/api/faq-answer/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {

                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteConstructorVariables.notifyMsgDeleteSuccess();
                    deleteConstructorVariables.fetchAnswersApi();

                } else {
                    if(res.result!=""){
                        deleteConstructorVariables.nNotifyFailToDelete(res.result);
                    }
                    deleteConstructorVariables.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });

    }

    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Answer Deleted Successfully</b>, {
            position: "top-center"
        });
    }

    nNotifyFailToDelete(response){
        toast.dismiss();
                toast(<b>{response}</b>, {
                    position: "top-center",
                    color: "red"
                });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchAnswersApi()
        this.setState({ disabled: false })
    }

    fetchAnswersApi = () => {
        var thisController = this;
        $.ajax({
            url: "/api/faq-answer",
            async: false,
            method: 'GET',
            data: {
                "questionId": thisController.props.location.state.faqid,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.setState({
                        data: messages,
                        disabled: false,
                    })
                }
                else {
                    thisController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/manage-knowledge/faq",
            state: { goBackToFaq: true,
            pageNum : pageNum
         }
        });
    }

    componentDidMount() {
        var faqid = this.props.location.state.faqid
        this.state.faqid = faqid;
        this.setState(this.state)
        setTimeout(() => {
            this.fetchAnswersApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            window.location.href = "/platform/projectmgmt/manage-knowledge/faq";
        });
    }

    onPageChange = (e) => {
        this.setState({pageNum : e})
    }

    render() {
        const { data } = this.state
        const columns = [
            {
                Header: 'Qno',
                accessor: 'id',
                show: false,
                Cell: props => (
                    <div name="id" id={"id" + props.index}>{props.original.id}
                    </div>)
            },
            {
                Header: <b>Answers</b>,
                accessor: 'answer',
                sortable: false, 
                Cell: props =>(
                    <div name="message" className="textarea"
                      type="text"
                        style={{ background: 'white', resize: 'none', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"answer" + props.index}

                        rows="1"
                        contentEditable={!((props.original.id == "") ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.original.answer}
                      
                    </div>)
            },

            {
                Header: <b>AutoTranslate</b>,
                accessor: 'autoTranslate',
                sortable: false,
                width: 100,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch">
                                <input type="checkbox"
                                    id={"autoTranslate" + props.index}
                                    defaultChecked={props.original.autoTranslate}
                                    disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },

            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">

                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none",
                                marginTop: '-13px'
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}

                                src={(props.original.id == "") ?
                                    this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == "") ?
                                        this.addAnswersApi(props, e) :
                                        (props.original.id == this.state.editedId) ?
                                            this.updateAnswerApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchAnswersApi() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index,
                                        propsId: props.original.id
                                    })}
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div style={{ background: "#F9F9FB" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div className="col-sm-4">
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    FAQ Answers</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            {/* Add button */}
                            <div className="col-sm-4" Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    {/* style={{ width: '45px',margin: '5px' }}>Refresh */}
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">
                                        {/* <div className="table-responsive manageClientTableBox"> */}
                                        <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                    </div>
                                    <ToastContainer className="Toast-at-center"/>

                                    {/*Dialog Component For Deletion Confirmation*/}
                                    <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Answers' showCloseIcon={true} buttons={this.buttons}
                                        ref={dialog => this.dialogInstance = dialog}
                                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete the Answer?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Answers


// WEBPACK FOOTER //
// ./src/projectmgmt/faq/Answers.js